import {
    UPDATE_DISCOUNT_CODE,
    UPDATE_DISCOUNT_CODE_FAILURE,
    UPDATE_DISCOUNT_CODE_SUCCESS,
} from 'store/actions/types';

export const updateDiscountCode = (payload) => {
    return {
        type: UPDATE_DISCOUNT_CODE,
        payload: payload,
    };
};

export const updateDiscountCodeFailure = (error) => {
    return {
        type: UPDATE_DISCOUNT_CODE_FAILURE,
        error: error,
    };
};

export const updateDiscountCodeSuccess = (payload, response) => {
    return {
        type: UPDATE_DISCOUNT_CODE_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/discountCodes/updateDiscountCodes.js